import {
  TECHNICIANS_SUCCESS,
  TECHNICIANS_ALLOCATED_TO_WORK_ORDER_SUCCESS,
} from '../actions/technicians'

export default function (state = [], action) {
  switch (action.type) {
    case TECHNICIANS_SUCCESS:
      return action.payload.result

    case TECHNICIANS_ALLOCATED_TO_WORK_ORDER_SUCCESS: {
      return action.payload.result
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/technicians.js